import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getCategory = createAsyncThunk("getCategory", async () => {
  try {
    let response = await axios.get(`${BASE_URL}/business/category/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log(error);
  }
});

const getCategorySlice = createSlice({
  name: "Add Business",
  initialState: {
    data: [],
    error: null,
    isLoading: false,
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: {
    [getCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    [getCategory.rejected]: (state, action) => {
      state.isLoading = false;
    },
  },
});

export default getCategorySlice;
